import React, {FC, useState} from 'react';
import {Link} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
} from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCog} from '@fortawesome/pro-solid-svg-icons/faCog';
import confirm from '@touchnet/react-confirm-modal';

import {AccountingCode} from '~/types/accounting-code-type'
import routes, {getRoute} from "~/route-map";
import Selectors from "~/state/selectors.ts";
import {actions} from "~/state/reducers/codes-reducer.ts";

interface ComponentProps {
    code: AccountingCode;
}

export const CodeListActionButton: FC<ComponentProps> = ({code}: ComponentProps) => {
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const cnum = useSelector(Selectors.getCustomerNumber);
    const ctx = useSelector(Selectors.getAppContext);

    const mainUrl = getRoute(routes.app.base,{cnum, ctx});
    const editLink = `${mainUrl}/ac/codes/${code.id}`;

    const onDelete = (name: string, codeId: string) => {
        confirm({
            cancelLabel: 'Never mind',
            children: `Are you sure you want to delete accounting code ${name}?`,
            okLabel: 'Yes, I\'m sure',
            title: 'Are you sure?',
        }).then(() => {
            dispatch(actions.deleteOneCode(codeId));
        });
    };

    const toggle = e => {
        e.stopPropagation();
        setIsOpen(!isOpen);
    };

    return (
        <Dropdown isOpen={isOpen} toggle={toggle}>
            <DropdownToggle outline size="sm" color="secondary">
                <span className="sr-only">
                    Accounting Code action button
                </span>
                <FontAwesomeIcon icon={faCog} />
            </DropdownToggle>
            <DropdownMenu end>
                <DropdownItem tag={Link} to={editLink}>
                    Edit
                </DropdownItem>
                <DropdownItem onClick={() => onDelete(code.name, code.id)}>
                    Delete
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
};

export default CodeListActionButton;
